import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAuthRequest, IAuthResponse } from '../models/auth.model';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private accountService: AccountService,
  ) {
  }

  private storageKey = 'ng_biilog_cliente';

  public login(credentials: IAuthRequest) {
    return this.http.post<IAuthResponse>(`${environment.api}/auth/login`, credentials).pipe(
      tap(res => this.accountService.saveSession(res.token, res.account)),
    )
    ;
  }


  public isAuthenticated(): boolean {
    const userData = localStorage.getItem(this.storageKey);
    if (!userData) {
      return false;
    }

    return true;
  }




}
